import {useRef, useState} from 'react';
import {BaSeIcon} from '@base/react';
import ShareDetailsPopup from './share-details-popup';
import lightbulb from '../../assets/images/icons/light.svg';
import './index.scss';
import {eventTag} from "../../services/utils";

const AvatarGroup = ({ users, maxVisible = 2, insidePlanning = false, isPlanner, onUserRemoved, postCredit = false, event = {} }) => {
  const [visiblePopup, setVisiblePopup] = useState(false);
  const toggleRef = useRef(null);
  const visibleUsers = users.slice(0, maxVisible);
  const extraCount = users.length - maxVisible;
  const extraUsers = users.slice(maxVisible);

  const getExtraUsersTooltip = () => {
    const firstThree = extraUsers.slice(0, 3);
    const remaining = extraCount - 3;

    let tooltip = firstThree.map(u => u.name).join(' | ');
    if (remaining > 0) {
      tooltip += ` | +${remaining}`;
    }
    return tooltip;
  };

  return (
    <div className="avatar-group" style={{ minWidth: maxVisible === 2 ? '108px' : 'auto' }}>
      {visibleUsers.map((user, index) => (
        <div key={index} className="avatar" data-tooltip={user.name} data-tooltip-position="top">
          <span>
            {user.name.charAt(0).toUpperCase() || ''}
          </span>
          {user.role === "Planejador" && (
            <div className="icon-role" data-tooltip="Planejador" data-tooltip-position="bottom">
              <img src={lightbulb} alt="Planejador" />
            </div>
          )}
        </div>
      ))}
      {extraCount > 0 && (
        <div className="avatar extra" data-tooltip={getExtraUsersTooltip()} data-tooltip-position="top">
          <span>
            +{extraCount}
          </span>
        </div>
      )}
      <div className="avatar-popup-container" ref={toggleRef}>
        <BaSeIcon
          color="#394D60"
          description="Usuários compartilhados"
          name={visiblePopup ? 'angle-up' : 'angle-down'}
          onClick={() => {
            eventTag(event?.name, "atendimento", event?.action, "Compartilhado com")
            setVisiblePopup(!visiblePopup)
          }}
          size={24}
        />
      </div>
      {visiblePopup && (
        <ShareDetailsPopup 
          users={users} 
          onClose={() => setVisiblePopup(false)} 
          insidePlanning={insidePlanning}
          toggleRef={toggleRef}
          isPlanner={isPlanner}
          onUserRemoved={onUserRemoved}
          postCredit={postCredit}
          event={event}
        />
      )}
    </div>
  );
};

export default AvatarGroup;
